function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Factory from './components/factory.vue';
import Workshop from './components/workshop.vue';
import Environment from './components/environment.vue';
export default {
  components: {
    Factory: Factory,
    Workshop: Workshop,
    Environment: Environment
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['globalData'])), {}, {
    produce: function produce() {
      return this.globalData.produce;
    },
    tabIndex: function tabIndex() {
      return this.$route.query.i || 0;
    }
  }),
  watch: {
    $route: {
      handler: function handler() {
        var _this = this;
        var index = this.$route.query.i || 0;
        this.$nextTick(function () {
          _this.scrollToSectionByTabIndex(index);
        });
      }
    }
  },
  mounted: function mounted() {
    var index = this.$route.query.i || 0;
    if (index > 0) {
      this.scrollToSectionByTabIndex(index);
    }
  },
  methods: {
    scrollToSectionByTabIndex: function scrollToSectionByTabIndex(tabIndex) {
      var index = Number(tabIndex);
      var sectionRefMap = {
        0: 'factorySection',
        1: 'workshopSection',
        2: 'environmentSection',
        3: 'environmentSection'
      };
      var refName = sectionRefMap[index];
      var target = this.$refs[refName];
      if (target && typeof target.scrollIntoView === 'function') {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  }
};